import React, { useContext, useMemo } from "react";
import { HvGrid } from "@hitachivantara/uikit-react-core";
import Container from "components/layout/Container";
import IncidentKpis from "components/map/IncidentsKpis";
import IncidentsTable from "components/map/IncidentsTable";
import NotFound from "components/common/NotFound";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";

const List: React.FC = () => {
  return (
    <Container maxWidth={false}>
      <HvGrid container>
        <HvGrid item xs={12}>
          <IncidentKpis />
        </HvGrid>
      </HvGrid>
      <HvGrid container>
        <HvGrid item xs={12}>
          <IncidentsTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const ListAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasModulePolicy(
      ModuleNames.incidentManagement,
      ModulePolicyTypes.incident
    );
  }, [hasModulePolicy]);
  return <>{hasRight ? <List /> : <NotFound />}</>;
};
export default List;
